import React from "react";
import "./HF.css"; // Create a CSS file for footer-specific styles
import { FaFacebook } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import Marquee from "react-fast-marquee";
// import world from "../assets/footerimage.jpg";

const Footer = () => (
  <div className="footer">
    {/* <img className="logo" src={world} alt="world" /> */}
    <div className="jjj">
      <div className="footer-container">
        {/* OUR MISSION STATEMENT */}
        <div className="mission">
        {/* <div className='marqueeh3'> */}
              <h3>LAYAM GROUP OF<span>COMPANIES</span></h3>
              <div className="marquee-container">
                <p className="marquee">Layam Flexi Solutions Pvt Ltd</p>
                <p className="marquee">Layam Management Solutions Pvt Ltd</p>
                <p className="marquee">Layam Talent Academy Foundations</p>
                <p className="marquee">Radram Quality Services Pvt Ltd</p>
              {/* </div> */}
            </div>



        </div>

        {/* OUR  SERVICES */}
        <div className="services">
          <h3>OUR SERVICES</h3>
          <li>
            <a
              href="https://layamgroup.com/about-vision/"
              target="_blank"
              className="support"
            >
              About us
            </a>
          </li>
          <li>
            <a
              href="https://layamgroup.com/#work-process"
              target="_blank"
              className="support"
            >
              Services
            </a>
          </li>
          <li>
            <a
              href="https://layamgroup.com/case_studies/"
              target="_blank"
              className="support"
            >
              Case Studies
            </a>
          </li>
          <li>
            <a
              href="https://layamgroup.com/awards/#loaded"
              target="_blank"
              className="support"
            >
              Awards
            </a>
          </li>

          <li>
            <a
              href="https://layamgroup.com/contact-us/"
              target="_blank"
              className="support"
            >
              Contact us
            </a>
          </li>
          <li>
            <a
              href="https://layamgroup.com/newsroom/"
              target="_blank"
              className="support"
            >
              Newsroom
            </a>
          </li>


        </div>

        {/* CONTACT US */}
        <div className="contact-us">
          <h3>CONTACT US</h3>
          <p>
            <strong>Layam Group</strong> <br />
            13/1, 5th Cross Street, Indra Nagar, Adyar, Chennai - 600020, India.
          </p>
          <p>
            <strong>Business Phone:</strong> <br />
            044 - 2445 2506, 044 - 2445 6449 <br />
            044 - 4063 9999, 044 - 2441 4599
          </p>
          <p>
            <strong>Support mail:</strong> <br />
            <a href="mailto:connectus@layamweb.com" className="support">
              connectus@layamweb.com
            </a>
          </p>
        </div>

        {/* NEWSLETTER & SOCIAL MEDIA */}
        <div className="newsletter">
          <h3>FOLLOW US</h3>
          <p>
            Don't miss out on interesting updates from Layam! Subscribe Now!
          </p>
          {/* <input type="email" placeholder="Your Email" />
            <button>📩</button> */}
          <div className="social-icons">
            <a
              href="https://facebook.com/LayamGroup"
              target="_blank"
              rel="noopener noreferrer"
              className="fbook"
            >
              <FaFacebook />
            </a>
            <a
              href="https://linkedin.com/company/layam-management-solutions-pvt-ltd"
              target="_blank"
              rel="noopener noreferrer"
              className="linkin"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://x.com/i/flow/login?redirect_after_login=%2FLayamGroup"
              target="_blank"
              rel="noopener noreferrer"
              className="twitter"
            >
              <FaXTwitter />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div className="line"></div>
    <div className="RENO">
      <p>&copy; 2025 RenoHR - All Rights Reserved.</p>
    </div>
    <div className="company">
      <h5>
        {" "}
        Developed by
        <span>
          <a href="https://ambrosyscorp.com/" target="blank" className="abs">
            AMBROSYS
          </a>
        </span>
      </h5>
    </div>
  </div>
);

export default Footer;